export default __webpack_public_path__ + "static/media/09-3D-(2-1).379099ed.jpg";